import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {TeamModel} from "../../models/team.model";

export class TeamsMultiSelectComponent implements IController {

  selectedIds: any;
  options: any;
  optionIds: string[];
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  onChange: Function;

  private teamsRef: any;
  public selectedTeams: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $teams, private $element) {
    this.teamsRef = this.$teams();
  }

  $onInit() {
    this._setSelectedTeams();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedTeams();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'teams';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        if (!selectedIds?.length) {
          this.onChange({teams: [], selectedIds: []});
          panel.destroy();
        } else {
          if (!!this.options) {
            const teams = _.filter(this.options, (o) => {
              return _.includes(selectedIds, o.id);
            });
            this.onChange({teams: teams, selectedIds: selectedIds});
            panel.destroy();
          } else {
            this.teamsRef.$asyncValues(selectedIds)
              .then((teams: TeamModel[]) => {
                this.onChange({teams: teams, selectedIds: selectedIds});
                panel.destroy();
              });
          }
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedIds: []});
  }

  private _setSelectedTeams() {
    if (!!this.selectedIds?.length) {
      if (!!this.options) {
        this.selectedTeams = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      } else {
        this.teamsRef.$asyncValues(this.selectedIds)
          .then((teams: TeamModel[]) => {
            this.selectedTeams = _.orderBy(teams, ['name'], ['asc']);
            this._setSelectedText();
          })
      }
    } else {
      this.selectedTeams = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedTeams, (b, i) => {
      string += b.name;
      if ((i + 1) < this.selectedTeams.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedTeams[0].name;
      if (this.selectedTeams.length - 1) {
        string += ` +${this.selectedTeams.length - 1}`
      }
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.teams')
  .component('teamsMultiSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedIds: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./teams-multi-select.html').default,
    controller: TeamsMultiSelectComponent
  });
